var $ = jQuery.noConflict();

var ThemeJS = {
  init: function () {
    this.mobileMenu();
    this.blogSlider();
    this.productPageSlider();
    // this.productInfoAccordion();
    this.productSubscribtionInfo();
    this.smoothScrollToAnchor();
    this.postRecipe();
    this.themeJs();
    this.tabs();
    this.philosophySlider();
    this.testimonialsSlider();
    this.doctorSlider();
    this.faq();
    this.resultsSlider();
    this.resultsImagesSlider();
    this.videoSlider();
    this.videoReviews();
  },
  productSubscribtionInfo: function () {
    var $infoEl = $('#js-sub-info');
    var $showBtn = $('#js-show-sub-info');
    var $hideBtn = $('#js-hide-sub-info');
    $showBtn.click(() => $infoEl.fadeIn(200));
    $hideBtn.click(() => $infoEl.fadeOut(200));
  },
  mobileMenu: function () {
    var $closeBtn = $('#js-close-mobile-nav');
    var $openBtn = $('#js-open-mobile-nav');
    var $mobileMenu = $('#js-mobile-menu');
    $closeBtn.click(function () {
      $mobileMenu.removeClass('open');
    });
    $openBtn.click(function () {
      $mobileMenu.addClass('open');
    });
  },
  blogSlider: function () {
    var $sliderEl = $('#js-slider');
    if ($sliderEl.length) {
      $sliderEl.slick({
        prevArrow: $('#js-slider-prev'),
        nextArrow: $('#js-slider-next'),
        slidesToShow: 3,
        centerMode: true,
        variableWidth: true,
      });
    }
  },
  resultsImagesSlider: function () {
    var $sliderEl = $('#js-results-images-slider');
    if ($sliderEl.length) {
      $sliderEl.slick({
        prevArrow: $('#js-results-images-slider-prev'),
        nextArrow: $('#js-results-images-slider-next'),
        slidesToShow: 2,
        infinite: true,
        slidesToScroll: 1,
        dots: true,
        appendDots: $('.results-slider-images__pagination'),
        responsive: [
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }
  },
  resultsSlider: function () {
    var $sliderEl = $('#js-results-slider');
    if ($sliderEl.length) {
      $sliderEl.slick({
        prevArrow: $('#js-results-slider-prev'),
        nextArrow: $('#js-results-slider-next'),
        slidesToShow: 4,
        infinite: true,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }
  },
  videoSlider: function () {
    var $sliderEl = $('#js-video-slider');
    if ($sliderEl.length) {
      $sliderEl.slick({
        prevArrow: $('#js-video-slider-prev'),
        nextArrow: $('#js-video-slider-next'),
        slidesToShow: 3,
        infinite: false,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }
  },
  videoReviews: function () {
    var $sliderEl = $('#js-video-reviews');
    if ($sliderEl.length) {
      $sliderEl.slick({
        prevArrow: $('#js-video-reviews-prev'),
        nextArrow: $('#js-video-reviews-next'),
        slidesToShow: 2,
        infinite: false,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 420,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }
  },
  productPageSlider: function () {
    var $mainSliderEl = $('#js-product-slider-main');
    var $bottomSliderEl = $('#js-product-slider-bottom');
    if ($mainSliderEl.length && $bottomSliderEl) {
      $mainSliderEl.slick({
        fade: true,
        arrows: true,
        prevArrow: $('#js-product-slider-arrow--prev'),
        nextArrow: $('#js-product-slider-arrow--next'),
        slidesToShow: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              fade: false,
            },
          },
        ],
      });
    }
  },
  productInfoAccordion: function () {
    var $productDescriptionEl = $('#js-product-description');
    if ($productDescriptionEl.length) {
      $($productDescriptionEl)
        .find('h5')
        .click(function () {
          if (!$(this).hasClass('expended')) {
            $($productDescriptionEl)
              .find('.expended')
              .toggleClass('expended')
              .next('div')
              .slideToggle(300);
          }
          $(this).toggleClass('expended');
          $(this).next('div').slideToggle(300);
        });
    }
  },
  smoothScrollToAnchor: function () {
    // For hash in url:
    var hash = window.location.hash;
    if (hash && $(hash).length) {
      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top,
        },
        1000,
      );
    }
  },
  postRecipe: function () {
    if ($('.post-recipe').length) {
      $('#js-recipeScroller').show();
      let title = $('.post-recipe h2').text();
      let media = $('.post-recipe img').attr('src');
      let url = encodeURIComponent($(location).attr('href'));
      let href =
        '//pinterest.com/pin/create/button/?url=' +
        url +
        '&amp;media=' +
        media +
        '&amp;description=' +
        title;
      console.log('href', href);
      $('.post-recipe').append(
        $(
          '<a target="_blank" class="post-recipe__btn" href="' +
            href +
            '" rel="null noopener">PIN IT</a>',
        ),
      );
      $(document).on('click', 'a[href="#recipe"]', function (event) {
        event.preventDefault();

        $('html, body').animate(
          {
            scrollTop: $('.post-recipe').offset().top - 50,
          },
          1000,
        );
      });
    }
  },
   themeJs: function () {
    $(".tooltip").change(function() {
        $(".tooltip").not(this).prop('checked', false);
    });
  },  
  philosophySlider: function() {
    var $sliderEl = $('#philosophy-slider');
    if ($sliderEl.length) {
      $sliderEl.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        adaptiveHeight: true,
        infinite: true,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
        		slidesToShow: 5,
             	centerMode: true,
                infinite: true,
              	adaptiveHeight: true,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1024,
            settings: {
              centerMode: true,
              slidesToShow: 4,
              infinite: true,
              centerMode: true,
              adaptiveHeight: true,
              centerPadding: '40px',
              slidesToScroll: 1
            }
          },
            {
            breakpoint: 1024,
              settings: {
                centerMode: true,
                slidesToShow: 4,
                infinite: true,
                centerMode: true,
                adaptiveHeight: true,
                centerPadding: '40px',
                slidesToScroll: 1
              }
            },{
            breakpoint: 768,
              settings: {
                centerMode: true,
                slidesToShow: 2,
                infinite: true,
                centerMode: true,
                adaptiveHeight: true,
                centerPadding: '10px',
                slidesToScroll: 1
              }
            },{
            breakpoint: 580,
              settings: {
                centerMode: true,
                slidesToShow: 1,
                infinite: true,
                centerMode: true,
                adaptiveHeight: true,
                centerPadding: '20px',
                slidesToScroll: 1
              }
            } ,{
            breakpoint: 480,
              settings: {
                centerMode: true,
                slidesToShow: 1,
                infinite: true,
                centerMode: true,
                adaptiveHeight: true,
                centerPadding: '50px',
                slidesToScroll: 1
              }
            } ,{
            breakpoint: 380,
              settings: {
                centerMode: true,
                slidesToShow: 1,
                infinite: true,
                centerMode: true,
                adaptiveHeight: true,
                centerPadding: '40px',
                slidesToScroll: 1
              }
            }   
         ],
      });
    }
  },  
   testimonialsSlider: function () {
    var $sliderEl = $('#tesimonials-slider');
    if ($sliderEl.length) {
      $sliderEl.slick({
        prevArrow: $('.hp-tesimonials__navigation-prev'),
        nextArrow: $('.hp-tesimonials__navigation-next'),
      });
    }
  },
  tabs: function () {
      $('.hp-features__tab-name').on('click', function() {
        show_content($(this).index());
      });

      show_content(0);

      function show_content(index) {
        // Make the content visible
        $('.tabcontent.visible').removeClass('visible');
        $('.tabcontent:nth-of-type(' + (index + 1) + ')').addClass('visible');

        // Set the tab to selected
        $('.hp-features__tab-name.selected').removeClass('selected');
        $('.hp-features__tab-name:nth-of-type(' + (index + 1) + ')').addClass('selected');
      } 
  }, 
  doctorSlider: function () {
    var $sliderEl = $('#doctors-slider');
    if ($sliderEl.length) {
      $sliderEl.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        infinite: true,
        responsive: [
          {
            breakpoint: 1160,
            settings: {
             	centerMode: true,
              	slidesToShow: 2,
                arrows: false,
        		centerPadding: '20px',
                adaptiveHeight: true,
            },
          },
          {
            breakpoint: 580,
            settings: {
              	slidesToShow: 1,
                arrows: false,
       			centerMode: true,
              	adaptiveHeight: true,
        		centerPadding: '80px'
            },
          }
        ],
      });
    }
  },  
  faq: function () {
      	$('.hp-faq__question').on('click', function(e) {		
      	$(this).toggleClass('hp-faq__question--active');
      	$(this).parent().find('.hp-faq__answer').slideToggle();
        $(this).parent().toggleClass('hp-faq--active');

		e.preventDefault();
		return false;
	});
  },  
};

$(document).ready(function () {
  ThemeJS.init();
});
// function addToCart(productID) {
//   console.log('add to cart', productID);
//   jQuery.post('/cart/add.js', {
//     items: [
//       {
//         quantity: 1,
//         id: productID,
//       },
//     ],
//   });
// }

// ////////////////
// addToCart();
// var cartContents = fetch('/cart.js')
//   .then((response) => response.json())
//   .then((data) => {
//     return data;
//   });

// console.log('cartContents', cartContents);

// $('#add-to-cart-button').click(function () {
//   var id = $(this).attr('data-productID');
//   console.log('add to cart', id);
//   addItemToCart(id, 1, '1', 'Months');
// });

// function addItemToCart(variant_id, qty, frequency, unit_type) {
//   data = {
//     id: variant_id,
//     quantity: qty,
//   };

//   jQuery.ajax({
//     type: 'POST',
//     url: '/cart/add',
//     data: data,
//     dataType: 'json',
//     success: function () {
//       document.documentElement.dispatchEvent(
//         new CustomEvent('cart:refresh', {
//           bubbles: true, //this code is for prestige theme, is to refresh the cart
//         }),
//       );
//     },
//   });
//   document.documentElement.dispatchEvent(
//     new CustomEvent('cart:refresh', {
//       bubbles: true, // same code for prestige theme
//     }),
//   );
// }
